import React from 'react';
import { useTranslation } from 'react-i18next';

function EmptyState() {
  const { t } = useTranslation('card');

  return (
    <div className="corporate-club-extract__card__body__empty-state">
      <span className="corporate-club-extract__card__body__empty-state__icon" />
      <p className="corporate-club-extract__card__body__empty-state__text">{t('empty')}</p>
    </div>
  );
}

export default EmptyState;
